<script lang="ts">
  // ARIA live-region host (AD-8). Story 1.1 wires the container; later stories
  // drive it with value and status announcements. Polite (`role="status"`) by
  // default so it never interrupts. Story 4.2 adds an ASSERTIVE variant
  // (`role="alert"`, `aria-live="assertive"`, EXPERIENCE.md L212) for the
  // central-absorption announcement, which must interrupt.
  let {
    message = '',
    assertive = false
  }: { message?: string; assertive?: boolean } = $props();
</script>

<div
  class="visually-hidden"
  role={assertive ? 'alert' : 'status'}
  aria-live={assertive ? 'assertive' : 'polite'}
  aria-atomic="true"
  data-testid={assertive ? 'live-region-assertive' : 'live-region'}
>
  {message}
</div>
